"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinksForEnv = exports.USER_SIGNUP_MODES = exports.SUPPORT_PHONE_NUMBERS = exports.GRAPHQL_ENDPOINTS = exports.ERROR_CODES = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// TODO: convert me to an Enum when we enable Typescript
var USER_SIGNUP_MODES = {
  AGENT: 'agent',
  PARTNER_BORROWER_POST_INVITE_ENROLL: 'partner_borrower_post_invite_enroll'
};
exports.USER_SIGNUP_MODES = USER_SIGNUP_MODES;
var ERROR_CODES = {
  HAS_ACCOUNT: 'HAS_ACCOUNT',
  IS_LOGGED_IN: 'IS_LOGGED_IN',
  OLD_TOKEN: 'OLD_TOKEN',
  MISSING_TOKEN: 'MISSING_TOKEN'
};
exports.ERROR_CODES = ERROR_CODES;

var getLinksForEnv = function getLinksForEnv(env) {
  var loginEmbedPath = '/borrower-enrollment/';
  var agentLoginEmbedPath = '/agent-enrollment/';
  var nonEnvDependentLinks = {
    privacyPolicy: 'https://earnup.com/privacy-policy/',
    trustPage: 'https://earnup.com/trust-policy/',
    termsOfService: 'https://app.earnup.com/account/docs/toc_flexpay_v2022_05_17.pdf'
  };

  if (env === 'production') {
    return (0, _extends2["default"])({
      appUrl: 'https://app.earnup.com',
      enterpriseAgentLoginAnonEmbedURL: "http://enterprise.earnup.com".concat(agentLoginEmbedPath),
      loginAnonEmbedURL: "https://app.earnup.com".concat(loginEmbedPath),
      loginUrl: "https://app.earnup.com/login"
    }, nonEnvDependentLinks);
  }

  if (env === 'development') {
    return (0, _extends2["default"])({
      appUrl: 'https://app.dev.tallac.earnup.com',
      enterpriseAgentLoginAnonEmbedURL: "https://mesa-verde.dev.tallac.earnup.com/".concat(agentLoginEmbedPath),
      loginAnonEmbedURL: "https://app.dev.tallac.earnup.com".concat(loginEmbedPath),
      loginUrl: "https://app.dev.tallac.earnup.com/login"
    }, nonEnvDependentLinks);
  }

  if (env === 'sandbox') {
    return (0, _extends2["default"])({
      appUrl: 'https://app.sandbox.earnup.com',
      enterpriseAgentLoginAnonEmbedURL: "https://enterprise.sandbox.earnup.com/".concat(agentLoginEmbedPath),
      loginAnonEmbedURL: "https://app.sandbox.earnup.com".concat(loginEmbedPath),
      loginUrl: "https://app.sandbox.earnup.com/login"
    }, nonEnvDependentLinks);
  } // Default = local


  return (0, _extends2["default"])({
    // TODO: Standardize this
    appUrl: 'http://localhost:3002',
    enterpriseAgentLoginAnonEmbedURL: "http://localhost:8080".concat(agentLoginEmbedPath),
    loginAnonEmbedURL: "http://localhost:8080".concat(loginEmbedPath),
    loginUrl: "http://localhost:3000/login"
  }, nonEnvDependentLinks);
};

exports.getLinksForEnv = getLinksForEnv;
var GRAPHQL_ENDPOINTS = {
  local: 'http://localhost:4000/pub',
  development: 'https://gql.dev.tallac.earnup.com/pub',
  sandbox: 'https://gql.sandbox.earnup.com/pub',
  production: 'https://gql.earnup.com/pub'
};
exports.GRAPHQL_ENDPOINTS = GRAPHQL_ENDPOINTS;
var SUPPORT_PHONE_NUMBERS = {
  "default": '(800) 209-9700',
  enterprise: '(888) 688-0250'
};
exports.SUPPORT_PHONE_NUMBERS = SUPPORT_PHONE_NUMBERS;